<template>
  <div class="personality-passion-content" id="plataforma-de-marca-personalidade-apaixonados-em-tudo" data-search-anchor>
    <div class="personality-passion-overlay-title-image">
      <h1 class="personality-passion-image-technology-title">
        {{ PersonalityPassionTitle }}
      </h1>
      <p class="personality-passion-image-technology-text">
        {{ PersonalityPassionTitle2}}
      </p>
    </div>

    <div
      class="personality-passion-banner-image"
      :style="{ backgroundImage: `url(${PersonalityPassionImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PersonalityPageMixin from '@/mixins/personality-page-mixin'
import {PersonalityPageStore } from '@/store/brand-plataform-page/personality-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PersonalityIPassionForEverythingSection extends Mixins(PersonalityPageMixin) {
  personalityPageStore: PageStoreContract = getModule(PersonalityPageStore, this.$store)

  get PersonalityPassionTitle(): string {
    return this.getElementText(4, 0)
  }

  get PersonalityPassionImageSrc(): string {
    return this.getElementMedia(4, 0)
  }

  get PersonalityPassionTitle2(): string {
    return this.getElementText(4, 1)
  }

  get PersonalityPassionTitle3(): string {
    return this.getElementText(4, 2)
  }

  async getPersonalityPageStore(): Promise<void> {
    await this.personalityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.personalityPageStore.isLoading) {
      await this.getPersonalityPageStore()
    }
  }
}
</script>

<style lang="scss">
.personality-passion-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px; 
}

.personality-passion-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.personality-passion-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.personality-passion-image-technology-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
  margin-bottom: 2rem;
  margin-top: 4rem;
}

.personality-passion-image-technology-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
